import Vue from 'vue'

import { httpHelper } from '@/utils'

const state = {
    activeSharedTracker: null,
    activeSharedTrackerTrace: [],
    isSharingTokenInvalid: false,
    sharedTrackers: [],
    sharingConfig: null,
}

const getters = {}

const actions = {
    async loadSharingData({ commit }, { token }) {
        try {
            commit('setSharingTokenInvalid', false)
            commit('common/setDataLoading', true, { root: true })
            const [assetsResponse, configResponse] = await Promise.all([
                httpHelper.get('/share/assets/', { params: { token } }),
                httpHelper.get('/share/config/', { params: { token } }),
            ])
            commit('setSharingConfig', configResponse.data)
            commit('setSharedTrackers', assetsResponse.data.results)
        } catch {
            commit('setSharingTokenInvalid', true)
            commit('setSharingConfig', null)
            commit('setSharedTrackers', [])
        } finally {
            commit('common/setDataLoading', false, { root: true })
        }
    },
}

const mutations = {
    setActiveSharedTracker(state, data) {
        if (!data) {
            state.activeSharedTrackerTrace = []
        } else if (data.id !== state.activeSharedTracker?.id) {
            state.activeSharedTrackerTrace = [
                [data.position.lat, data.position.lng],
            ]
        }

        state.activeSharedTracker = data
    },
    setSharingConfig(state, data) {
        state.sharingConfig = data
    },
    setSharingTokenInvalid(state, data) {
        state.isSharingTokenInvalid = data
    },
    setSharedTrackers(state, data) {
        state.sharedTrackers = data
    },
    updateTracker(state, { asset: id, ...data }) {
        const index = state.sharedTrackers.findIndex(
            tracker => tracker.id === id
        )
        const tracker = state.sharedTrackers[index]

        if (!tracker) {
            return
        }

        tracker.last_contact = data.timestamp

        if ('lat' in data && 'long' in data) {
            tracker.position.lat = data.lat
            tracker.position.lng = data.long
            tracker.position.timestamp = data.timestamp

            if (state.activeSharedTracker?.id === id) {
                state.activeSharedTrackerTrace = [
                    [data.lat, data.long],
                    ...state.activeSharedTrackerTrace,
                ]
            }
        }

        if ('values' in data) {
            Object.entries(data.values).forEach(([key, value]) => {
                tracker.sensor_data[key] = {
                    value,
                    last_update: data.timestamp,
                }
            })
        }

        Vue.set(state.sharedTrackers, index, tracker)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
